import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Dialog from "../../components/Dialog";
import InputTextStyles from "../../styles/components/InputTextStyles";
import { StyledInfoLabel } from "../../styles/pages/Schedule/ModalViewDetailsStyles";
import UploadFileStyles from "../../styles/pages/UploadFilesStyles";
import ButtonStyles from "../../styles/components/ButtonStyles";

function DialogCreateAbono(props: any) {
    const [nomeAbono, setNomeAbono] = useState("");
    const [qtdAfastamento, setQtdAfastamento] = useState(1);
    const { StyledImportButton, StyledModalTitle, StyledContainerBody } =
        UploadFileStyles;
    const { StyledFormControl } = InputTextStyles;
    const { DefaultButtonLink } = ButtonStyles;

    return (
        <Dialog openModal={props.createModal} onHide={props.onHide}>
            <StyledModalTitle>Criar Abono</StyledModalTitle>
            <div style={{ height: 20 }} />
            <StyledContainerBody>
                <Container>
                    <Col>
                        <StyledInfoLabel>
                            Nome do motivo do abono
                        </StyledInfoLabel>
                    </Col>
                    <div>
                        <StyledFormControl
                            type="text"
                            placeholder="Nome do motivo do abono"
                            onChange={(e: any) =>
                                setNomeAbono(e.target.value as string)
                            }
                            value={nomeAbono}
                        />
                    </div>
                </Container>
                <div style={{ height: 20 }} />
                <Container>
                    <Col>
                        <StyledInfoLabel>
                            Quantidade de dias de afastamento
                        </StyledInfoLabel>
                    </Col>
                    <div>
                        <StyledFormControl
                            type="number"
                            min="1"
                            max="99"
                            placeholder="Quantidade de dias de afastamento"
                            onChange={(e: any) =>
                                setQtdAfastamento(e.target.value as number)
                            }
                            value={qtdAfastamento}
                        />
                    </div>
                </Container>
            </StyledContainerBody>
            <Row style={{ justifyContent: "center" }}>
                <StyledImportButton
                    style={{ width: 126, marginTop: 24 }}
                    onClick={() => {
                        props.handleSubmitCreate(nomeAbono, qtdAfastamento);
                    }}
                    disabled={nomeAbono === ""}
                >
                    Confirmar
                </StyledImportButton>
            </Row>
            <div style={{ height: 15 }} />
            <Row style={{ justifyContent: "center" }}>
                <DefaultButtonLink
                    onClick={() => {
                        props.onHide?.();
                    }}
                >
                    Cancelar
                </DefaultButtonLink>
            </Row>
        </Dialog>
    );
}

export default DialogCreateAbono;
